import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductsService } from './lib/services/products.service';
import { StorageService } from './lib/services/storage.service';
import { Constants } from 'src/app/config/constants';
import { Storage } from '@ionic/storage-angular';
import { LoaderComponent } from './components/loader/loader.component';
import { Platform } from '@ionic/angular';
import { NotificationService } from './lib/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { WebserviceWorkerService } from './lib/services/webservice-worker.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  showLoader: boolean = true;
  @ViewChild(LoaderComponent) loaderComponent!: LoaderComponent;

  constructor(
    private productsService: ProductsService,
    private storageService: StorageService,
    private storage: Storage,
    private platform: Platform,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private webServiceWorkerService: WebserviceWorkerService,
  ) {
    this.platform.ready().then(async (res: any) => {
      await this.storage.create();
      this.getSpashScreenData();
    });
  }

  async ngOnInit() {
    this.notificationService.getToken();
    this.notificationService.initMessageListener();
    this.subscribeToMessages();
  }

  getSpashScreenData() {
    this.productsService.getSplashApi().subscribe((res: any) => {
      setTimeout(() => {
        this.loaderComponent.fadeOut(); // add this line
        setTimeout(() => {
          this.showLoader = false;
        }, 300); // adjust the delay to match your animation duration
      }, 500);
      if (res && res.data && res.data.helpVideos) {
        this.storageService.setItem(Constants.HELP_VIDEOS, res.data.helpVideos); //setting help video's link in locaal storage...
      }
    }, error => {
      setTimeout(() => {
        this.loaderComponent.fadeOut(); // add this line
        setTimeout(() => {
          this.showLoader = false;
        }, 300); // adjust the delay to match your animation duration
      }, 500);
      console.error(error);
    });
  }

  subscribeToMessages() {
    this.notificationService.message$.subscribe((message) => {
      this.toastr.info(message.body, message.title, {
        closeButton: true,
        disableTimeOut: true
      })
    });
  }
}
